import {
  Creator as ApiCreator,
  IdealistDayEvent as ApiIdealistDayEvent,
} from 'api/groups';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action } from '../actions/idealistDayEvents';

export type IdealistDayEvent = ApiIdealistDayEvent & {
  isFetching: boolean;
};
export type Creator = ApiCreator;
export type State = {
  byId: Record<
    string,
    IdealistDayEvent & {
      isFetching: boolean;
    }
  >;
};
export default function events(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    byId: {},
  },
  action: Action
) {
  switch (action.type) {
    case 'FETCH_IDEALIST_DAY_EVENT_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.eventId]: {
            ...state.byId[action.eventId],
            id: action.eventId,
            isFetching: true,
          },
        },
      };

    case 'FETCH_IDEALIST_DAY_EVENT_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.event.id]: { ...action.event, isFetching: false },
        },
      };

    default:
      // this causes a flow error if there are any unhandled actions
      action as never; // eslint-disable-line no-unused-expressions

      return state;
  }
}
